<template>
  <div>
    <v-layout class="delivery-schedule">
      <v-flex>
        <v-data-table :items="creativeSchedules" hide-actions>
          <template v-slot:headers>
            <tr class="header-row grey lighten-3">
              <th @click="$emit('sort')">
                配信スケジュール
                <v-icon small>sort</v-icon>
              </th>
            </tr>
          </template>
          <template v-slot:items="{ item, index }">
            <tr
              @click="$emit('input', item)"
              :class="{ 'blue lighten-2 white--text': isSelected(item, index) }"
              class="itemRow"
            >
              <td>
                <v-layout
                  @click="setCurrent(item)"
                  text-xs-center
                  align-center
                  align-content-center
                >
                  <AppWarning
                    :warningMessages="warningMessages(item)"
                    :errorMessages="errorMessages(item)"
                  />
                  <v-flex row wrap align-center xs11>
                    <EditCreativeSchedule
                      v-model="item"
                      :campaignBudget="campaignBudget"
                      :readOnly="readOnly"
                    />
                  </v-flex>
                  <v-flex v-if="!readOnly" xs1>
                    <v-tooltip v-if="index > 0" top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          @click="onDeleteClick(index)"
                          v-on="on"
                          icon
                          small
                          color="error"
                        >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </template>
                      <span>配信スケジュール削除</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <td colspan="2">
              <div class="text-xs-center">
                <slot name="empty" />
              </div>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <div class="add-button-field">
        <CreativeScheduleButtonAdd v-if="showAddButton" @onClick="onAddClick" />
      </div>
    </v-layout>
  </div>
</template>

<script>
import { css } from 'emotion'
import dayjs from 'dayjs'
import { CreativeScheduleFormModel } from '@/models/CampaignOperation/Form'
import EditCreativeSchedule from '@/components/Advertiser/Operation/IO/Form/EditCreativeScheduleRangeForm'
import CreativeScheduleValidation from '@/models/CampaignOperation/Form/CreativeScheduleValidation'
import CreativeScheduleButtonAdd from '@/components/Advertiser/Operation/IO/CampaignModalPageCreativeButtonAdd'

export default {
  name:
    'CampaignModalPageCreativeModeCampaignWithSchedulesCampaignBudgetPeriodTable',
  components: {
    EditCreativeSchedule,
    CreativeScheduleButtonAdd,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    creativeSchedules: {
      type: Array,
      default: () => [],
    },
    campaignBudget: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isStartTimeEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultStartDateTime: '00:00:00',
      defaultEndDateTime: '23:59:59',
    }
  },
  computed: {
    showAddButton() {
      return this.creativeSchedules && !this.readOnly && this.isEditable
    },
    isEditable() {
      if (!this.campaignBudget) return false
      const nowDate = dayjs().startOf('day')
      return dayjs(this.campaignBudget.endDate).isAfter(nowDate)
    },
  },
  methods: {
    isSelected(item) {
      return this.value && this.value === item
    },
    icon(item) {
      if (item.hasWarning) {
        return 'warning'
      } else {
        return ''
      }
    },
    iconStyles(item) {
      return [
        css`
          width: 30px;
        `,
        {
          'yellow--text text--darken-2': item.hasWarning,
        },
      ]
    },
    warningMessage(item) {
      return item
    },
    setCurrent(item) {
      this.$emit('select', item)
    },
    onAddClick() {
      this.creativeSchedules.push(
        new CreativeScheduleFormModel.assign({
          startTime: this.makeAddStartDateTime(
            this.creativeSchedules[this.creativeSchedules.length - 1],
          ),
        }),
      )
    },
    makeAddStartDateTime(creativeSchedule) {
      if (
        !creativeSchedule.endTime ||
        creativeSchedule.endTime === this.campaignBudget.endTime
      ) {
        return dayjs(this.campaignBudget.endTime).format(
          `YYYY-MM-DD ${this.defaultStartDateTime}`,
        )
      }
      return dayjs(creativeSchedule.endTime)
        .add(1, 'second')
        .format('YYYY-MM-DD HH:mm:ss')
    },
    onDeleteClick(index) {
      this.creativeSchedules.splice(index, 1)
    },
    warningMessages(creativeSchedule) {
      return CreativeScheduleValidation.getWarningMessagesByCreativeSchedule(
        creativeSchedule,
      )
    },
    errorMessages(creativeSchedule) {
      return CreativeScheduleValidation.getErrorMessages(
        this.campaignBudget,
        creativeSchedule,
      )
    },
  },
}
</script>

<style scoped lang="scss">
.header-row {
  height: 33px;
  width: 100%;
  th {
    padding: 0 8px !important;
    text-align: left;
  }
}

.itemRow {
  cursor: pointer;

  td {
    padding: 0 !important;
  }
}
.delivery-schedule {
  height: 258px;
}
.add-button-field {
  position: relative;
  height: 100%;
}
</style>
